import {Component, input} from '@angular/core';
import {ApiService} from '../../../_services/api.service';
import {FormDetail} from '../../file-online-v2/models/api/Form';
import {PdfUrlRowComponent} from '../../../_shared/pdf-url-row/pdf-url-row.component';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import event = google.maps.event;

@Component({
  selector: 'app-form-list-row',
  standalone: true,
  imports: [
    PdfUrlRowComponent,
    NgbTooltip
  ],
  templateUrl: './form-list-row.component.html',
  styleUrl: './form-list-row.component.scss'
})
export class FormListRowComponent {

  formEntry = input.required<FormDetail>();

  constructor(protected apiService: ApiService) {
  }

  handleEFilePreClick(event: MouseEvent): void {
    if (this.formEntry().eFileMaintenance) {
      event.preventDefault();
    }
  }
}
